import React from "react";
import "../../assets/css/style.css";
import "./CSS/Enhanced.css";
import "./CSS/Medias.css";
import InvitationText from "../InvitationText";

class BotanicalSage extends React.Component {
  constructor(props) {
    super(props);
    this.isSideBySide = props.isSideBySide;
  }

  render() {
    const bodyStyle = this.isSideBySide
      ? "body-style-regular-save-date"
      : "body-style-classic-save-date";
    return (
      <div id="fullCard" className="botanicalSage-save-date" style={{ height: "100%", width: "100%" }}>
        {this.props.isSideBySide && <div className="watermark"></div>}
        <div className={bodyStyle}>
          <InvitationText
            reqObject={this.props.reqObject}
            handleReqObject={this.handleReqObject}
            isSakura={false}
          />
        </div>
      </div>
    );
  }
}

export default BotanicalSage;
